import React from 'react';
import './HomeReferralButton.css';
import referralIcon from '../images/icons/ic_referal.png';
import { triggerHaptic } from '../services/telegram';

function HomeReferralButton({ onOpenReferral }) {
  const handleClick = () => {
    triggerHaptic();
    onOpenReferral?.();
  };

  return (
    <button className="home-referral-button" onClick={handleClick}>
      <img src={referralIcon} alt="" className="button-icon" />
      <span className="button-text">Реферальная программа</span>
      <span className="button-platform">100₽ за друга</span>
    </button>
  );
}

export default HomeReferralButton;
